module.exports = __webpack_public_path__ + "img/england_icc.19509fc1.png";